// eslint-disable
import { useState } from 'react';
import cns from 'classnames';
// @ts-expect-error -- config.js is `module.exports = <runtime value>`, so TypeScript sees no named exports
import { DOMAIN_PREFIX_BY_LOCALES } from 'config';
import createCookies from 'helpers/cookies';

import cn from './styles.local.less';

interface ButtonProps {
  locale: string; // keyof DOMAIN_PREFIX_BY_LOCALES;
  flag: string;
  withForceLocale?: boolean;
}

const cookies = createCookies();

const buttonPropsMap: { [key: string]: ButtonProps } = {
  germany: { locale: 'de', flag: '🇩🇪', withForceLocale: true },
  netherlands: { locale: 'nl', flag: '🇳🇱', withForceLocale: true },
  spain: { locale: 'es', flag: '🇪🇸', withForceLocale: true },
  italy: { locale: 'it', flag: '🇮🇹', withForceLocale: true },
  france: { locale: 'fr', flag: '🇫🇷', withForceLocale: true },
  sweden: { locale: 'sv-se', flag: '🇸🇪', withForceLocale: true },
  austria: { locale: 'de-at', flag: '🇦🇹', withForceLocale: true },
  belgium: { locale: 'nl-be', flag: '🇧🇪', withForceLocale: true },
};

const getIsNeedRender = () => {
  if (!__CLIENT__) return false;

  return localStorage.getItem('qa') === 'kimo'; // will be removed after test;
};

function DevTool() {
  const needRender = getIsNeedRender();

  const [isOpened, setIsOpened] = useState(false);

  if (!needRender) {
    return null;
  }

  const handleClick = (e: any) => {
    const targetCountry = e.target.name;
    const { locale, withForceLocale } = buttonPropsMap[targetCountry];
    const forceLocale = withForceLocale ? locale : '';
    const domainPrefix = DOMAIN_PREFIX_BY_LOCALES[locale];

    cookies.set('forceLocale', String(forceLocale));

    window.location.href = `/${domainPrefix}/?ssr=no`;
  };

  const handleToggleOpened = () => {
    setIsOpened(!isOpened);
  };

  const countries = Object.keys(buttonPropsMap);
  const rootClassName = cns(cn.root, {
    [cn.isOpened]: isOpened,
  });

  return (
    <div className={rootClassName}>
      <span className={cn.closeBtn} onClick={handleToggleOpened}>
        {isOpened ? 'X' : '>'}
      </span>

      {countries.map((country: string) => {
        return (
          <button key={country} name={country} onClick={handleClick}>
            {buttonPropsMap[country].flag}
          </button>
        );
      })}
    </div>
  );
}

export default DevTool;
